import QmulusUi from '@qmulus/ui';
import * as Sentry from '@sentry/vue';
import {
  createPinia,
} from 'pinia';
import {
  createApp,
} from 'vue';
import './main.css';

import App from './app.vue';
import router from './router';

import packageInfo from '@/../package.json';
import {
  keycloakAuthenticationHandler,
} from '@/authentication.ts';
import config from '@/config/config';
import {
  i18n,
} from '@/plugins/i18n.ts';
import {
  registerPrimevue,
} from '@/plugins/primevue.ts';

import '@/plugins/dayjs.ts';

keycloakAuthenticationHandler.initialize().then(() => {
  const app = createApp(App);
  const pinia = createPinia();

  if (config.VITE_SENTRY_DSN && import.meta.env.MODE === 'production') {
    Sentry.init({
      app,
      dsn: config.VITE_SENTRY_DSN,
      environment: config.VITE_SENTRY_ENVIRONMENT,
      release: `Qmulus@${packageInfo.version}`,
      integrations: [
        Sentry.browserTracingIntegration({
          router,
        }),
        Sentry.replayIntegration(),
      ],

      // will spam A LOT in console
      // debug,

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,

      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      // enable if required
      // tracePropagationTargets: [
      //   'local.qmulus.ai',
      //   /^https:\/\/yourserver\.io\/api/,
      // ],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  app.use(pinia);
  app.use(router);
  app.use(i18n);
  app.use(QmulusUi, {
    i18n,
  });
  registerPrimevue(app);

  app.mount('#app');
});
